<template lang="pug">
  v-main
    page-header
    .gvl-content.px-5.pt-8
      router-view
    page-footer

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

@Component({
  components: {
    PageHeader: () => import('@/components/page-header'),
    PageFooter: () => import('@/components/page-footer'),
  }
})
export default class Base extends Vue {

}
</script>

<style lang="sass">
.gvl-content
  min-height: calc(100vh - 660px)

.overlay-spinner
  position: fixed
  top: 0
  left: 0
  bottom: 0
  right: 0
  display: flex
  align-items: center
  justify-content: center
  background-color: rgba(0, 0, 0, 0.3)
  z-index: 99
</style>
